import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationFacade } from '@cash/shared/authentication';

@Component({
    selector: 'cash-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent {
  constructor(
    private authenticationFacade: AuthenticationFacade,
    private router: Router,
  ) {
  }

  checkBrowserLanguage(languages: string[]) {
    const browserLanguage = navigator.languages[0];
    return languages.some(
      (language) =>
        browserLanguage && (browserLanguage ? browserLanguage.indexOf(language) : null) > -1
    );
  }

  logout() {
    this.authenticationFacade.logOut();
    this.router.navigateByUrl('/').then();
  }
}
